import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';

export interface AnexoDestinoDTO {
  codigo: string;
  nombre: string;
  descripcion?: string;
  estado?: string;
  valorTarifa?: number;
  // Campos de elegibilidad (si el backend los entrega).
  edadMinima?: number | null;
  edadMaxima?: number | null;
  genero?: string | null;
  parentesco?: string | string[] | null;
}

@Injectable({
  providedIn: 'root',
})
export class AnexosDestinoService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.ANEXOS_DESTINO}`;

  constructor(private http: HttpClient) {}

  getAnexosDestino(): Observable<AnexoDestinoDTO[]> {
    return this.http.get<AnexoDestinoDTO[]>(this.apiUrl);
  }
}
